import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-cell-action-menu',
    templateUrl: './cell-action-menu.component.html',
    //    styleUrls: ['./cell-action-menu.component.scss']
})
export class CellActionMenuComponent implements OnChanges {
    @Input() cellactiontop: string;
    @Input() cellactionleft: string;
    @Input() cellactionvisible: boolean;
    @Input() cellactionmenuvisible: boolean;
    @Input() curSelectedRow: number;
    @Input() outputrow: number;
    @Input() project: any;
    @Input() contextmenuitem: number;
    @Input() contextmenuitem1: number;
    @Input() sheetid: number;
    @Input() menustyle: string = 'default';

    @Output() addGuiEvent = new EventEmitter<{ type: string, insertLocation: 'selected' }>();
    @Output() addPrimitiveEvent = new EventEmitter<{ type: string, insertLocation: 'selected' }>();
    @Output() showfilesDialogEvent = new EventEmitter<any>();
    @Output() addProjectEvent = new EventEmitter<void>();
    @Output() exportSceneEvent = new EventEmitter<void>();
    @Output() openInsertObjectDialogEvent = new EventEmitter<void>();
    @Output() toggleMenuEvent = new EventEmitter<void>();

    showOverlaymenu1 = false;
    showSheetsmenu = false;
    showOverlaymenu = false;
    showothermenu = false;

    // Pagination properties
    currentControlPage = 0;
    currentObjectPage = 0;
    itemsPerPage = 8;

    // Control items configuration
    controlItems = [
        { title: 'Label', icon: 'fa fa-tags', action: () => this.addGui('label') },
        { title: 'Textbox', icon: 'fa fa-edit', action: () => this.addGui('textbox') },
        { title: 'Number', icon: 'fa fa-calculator', action: () => this.addGui('number') },
        { title: 'Checkbox', icon: 'fa fa-check-square', action: () => this.addGui('checkbox') },
        { title: 'Radio', icon: 'fa fa-dot-circle', action: () => this.addGui('radio') },
        { title: 'Image', icon: 'fa fa-image', action: () => this.showfilesDialog('png') },
        { title: 'Select', icon: 'fa fa-list', action: () => this.addGui('select') },
        { title: 'Slider', icon: 'fa fa-sliders', action: () => this.addGui('slider') },
        { title: 'Button', icon: 'fa fa-hand-pointer', action: () => this.addGui('button') },
        { title: 'Color Chooser', icon: 'fa fa-palette', action: () => this.addGui('colorchooser') },
        { title: 'Color Palette', icon: 'fa fa-palette', action: () => this.addGui('colorchooser (predefined palette)') },
        { title: 'Custom Color Set', icon: 'fa fa-palette', action: () => this.addGui('colorchooser (custom colors)') },
        { title: 'HTML', icon: 'fa fa-code', action: () => this.addGui('html') },
        { title: 'Save Button', icon: 'fa fa-save', action: () => this.addGui('savebutton') },
        { title: 'Export Button', icon: 'fa fa-download', action: () => this.addGui('exportbutton') },
        { title: 'Timer', icon: 'fa fa-clock', action: () => this.addGui('timer') }
    ];

    // Object items configuration
    objectItems = [
        { title: 'Extrusion', icon: 'fa fa-cube', action: () => this.addPrimitive('extrusion') },
        { title: '3D File', icon: 'fa fa-file-archive', action: () => this.showfilesDialog('gltf') },
        { title: 'Line', icon: 'fa fa-minus', action: () => this.addPrimitive('line') },
        { title: 'Dimension Line', icon: 'fa fa-ruler', action: () => this.addPrimitive('dimensionline') },
        { title: 'Shape', icon: 'fa fa-star', action: () => this.addPrimitive('shape') },
        { title: 'Cube', icon: 'fa fa-square', action: () => this.addPrimitive('cube') },
        { title: 'Cylinder', icon: 'fa fa-circle', action: () => this.addPrimitive('cylinder') },
        { title: 'I-Beam', icon: 'fa fa-industry', action: () => this.addPrimitive('ibeam') },
        { title: 'Image', icon: 'fa fa-image', action: () => this.showfilesDialog('png', false, true) },
        { title: 'Text Flat', icon: 'fa fa-font', action: () => this.addPrimitive('textflat') },
        { title: 'Project', icon: 'fa fa-folder-open', action: () => this.openInsertObjectDialog() },
        { title: 'Sphere', icon: 'fa fa-circle-o', action: () => this.addPrimitive('sphere') },
        { title: 'Capsule', icon: 'fa fa-capsules', action: () => this.addPrimitive('capsule') },
        { title: 'Ring', icon: 'fa fa-ring', action: () => this.addPrimitive('ring') },
        { title: 'Surface', icon: 'fa fa-mountain', action: () => this.addPrimitive('surface') },
        { title: 'Light', icon: 'fa fa-lightbulb-o', action: () => this.addPrimitive('light') },
        { title: 'Profile', icon: 'fa fa-bezier-curve', action: () => this.addPrimitive('profile') },
        { title: 'Connector', icon: 'fa fa-plug', action: () => this.addPrimitive('connector') },
        { title: 'Grid', icon: 'fa fa-grid', action: () => this.addPrimitive('grid') },
        { title: 'Arrow', icon: 'fa fa-arrow-right', action: () => this.addPrimitive('arrow') },
        { title: 'Tube', icon: 'fa fa-tube', action: () => this.addPrimitive('tube') },
        { title: 'Subtraction', icon: 'fa fa-minus-square', action: () => this.addPrimitive('subtraction') },
        { title: 'Union', icon: 'fa fa-plus-square', action: () => this.addPrimitive('union') },
        { title: 'Text 2D', icon: 'fa fa-text-width', action: () => this.addPrimitive('text2d') },
        { title: 'Rectangle 2D', icon: 'fa fa-square-o', action: () => this.addPrimitive('rectangle2d') },
        { title: 'Overlay HTML', icon: 'fa fa-code', action: () => this.addPrimitive('overlayhtml') }
    ];

    ngOnChanges(changes: SimpleChanges) {
        // Check if cellactionmenuvisible changed
        console.log('onchanges cellactionmenuvisible', this.cellactionmenuvisible, changes);

        // Only react to changes if the expanded menu is not currently visible
        // If cellactionmenuvisible is true, the user has manually expanded the menu
        // and we should not close it based on cellactionvisible changes
        if (!this.cellactionmenuvisible) {
            // Only close submenus when cellactionvisible changes to false
            if (changes?.cellactionvisible?.currentValue === false) {
                this.hideallsubmenus();
            }
        }

        // When the main menu becomes invisible, also hide all submenus
        if (changes?.cellactionvisible && changes.cellactionvisible.currentValue === false) {
            this.hideallsubmenus();
        }

        // If cellactionmenuvisible is true, ignore cellactionvisible changes
        // The expanded menu should only be closed by explicit user action
    }

    addGui(type: string, event?: Event) {
        if (event) {
            event.stopPropagation();
        }
        this.addGuiEvent.emit({ type, insertLocation: 'selected' });
    }

    addPrimitive(type: string, event?: Event) {
        if (event) {
            event.stopPropagation();
        }
        this.addPrimitiveEvent.emit({ type, insertLocation: 'selected' });
    }

    showfilesDialog(type: string, arg2?: boolean, arg3?: boolean, event?: Event) {
        if (event) {
            event.stopPropagation();
        }
        this.showfilesDialogEvent.emit({ type, arg2, arg3 });
    }

    addProject(event?: Event) {
        if (event) {
            event.stopPropagation();
        }
        this.addProjectEvent.emit();
    }

    openInsertObjectDialog(event?: Event) {
        if (event) {
            event.stopPropagation();
        }
        this.openInsertObjectDialogEvent.emit();
    }

    showhidemenu(event?: Event) {
        // Prevent event propagation to avoid immediate closing
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        // Add extra delay to prevent immediate document click from closing menu
        setTimeout(() => {
            // Emit event to parent component to toggle menu visibility
            this.toggleMenuEvent.emit();
            console.log('showhidemenu - emitting toggle event');
        }, 10);


        // Get window height and element height
        const windowHeight = window.innerHeight;
        const menuElement = document.querySelector('.cell-action-menu') as HTMLElement;
        const menuHeight = menuElement ? menuElement.offsetHeight : 250; // Use actual height if available, fallback to 200px

        // Calculate if menu would go off screen
        var top = parseInt(this.cellactiontop.replace('px', ''));
        const wouldGoOffScreen = (top + menuHeight) > windowHeight;

        // Position menu above or below based on available space
        if (wouldGoOffScreen) {
            // Position menu above the cell if not enough space below
            this.cellactiontop = (top - menuHeight - 10) + 'px';
        } else {
            // Position menu below the cell
            this.cellactiontop = (top + 10) + 'px'; // Add small padding
        }

        if (!this.cellactionmenuvisible) {
            this.hideallsubmenus();
        }
    }

    hideallsubmenus() {
        this.showOverlaymenu1 = false;
        this.showSheetsmenu = false;
        this.showOverlaymenu = false;
        this.showothermenu = false;
    }

    exportScene() {
        this.exportSceneEvent.emit();
    }

    // Pagination methods for controls
    get totalControlPages(): number {
        return Math.ceil(this.controlItems.length / this.itemsPerPage);
    }

    getCurrentControlItems() {
        const startIndex = this.currentControlPage * this.itemsPerPage;
        return this.controlItems.slice(startIndex, startIndex + this.itemsPerPage);
    }

    nextControlPage() {
        this.currentControlPage = (this.currentControlPage + 1) % this.totalControlPages;
    }

    // Pagination methods for objects
    get totalObjectPages(): number {
        const allObjectItems = this.getAllObjectItems();
        return Math.ceil(allObjectItems.length / this.itemsPerPage);
    }

    getCurrentObjectItems() {
        const allObjectItems = this.getAllObjectItems();
        const startIndex = this.currentObjectPage * this.itemsPerPage;
        return allObjectItems.slice(startIndex, startIndex + this.itemsPerPage);
    }

    // Get all object items including dynamic sheet items
    getAllObjectItems() {
        const sheetItems = this.getSheetItems();
        return [...this.objectItems, ...sheetItems];
    }

    // Generate dynamic sheet items
    getSheetItems() {
        if (!this.project?.sheets) return [];

        return this.project.sheets
            .map((sheet: any, index: number) => {
                if (index > 0) { // Skip first sheet (main sheet)
                    return {
                        title: `Sheet: ${sheet.name}`,
                        icon: 'fa fa-table',
                        action: () => this.addPrimitive(`sheet: ${sheet.name}`)
                    };
                }
                return null;
            })
            .filter((item: any) => item !== null);
    }

    nextObjectPage() {
        this.currentObjectPage = (this.currentObjectPage + 1) % this.totalObjectPages;
    }

    // Helper method to calculate circular positions
    getCircularPosition(index: number, totalItems: number): { top: string, left: string } {
        const centerX = 30;
        const centerY = 30;
        const radius = 80;
        const angleStep = (2 * Math.PI) / Math.min(totalItems, this.itemsPerPage);
        const angle = index * angleStep - (Math.PI / 2); // Start from top (12 o'clock)

        const x = centerX + radius * Math.cos(angle);
        const y = centerY + radius * Math.sin(angle);

        return {
            top: `${y}px`,
            left: `${x}px`
        };
    }
}
